import intl, { Text } from '$gintl';

export { Text };

export default intl;
